import { render, staticRenderFns } from "./OrganisationCreated.vue?vue&type=template&id=39ac3caf&scoped=true"
import script from "./OrganisationCreated.vue?vue&type=script&lang=ts"
export * from "./OrganisationCreated.vue?vue&type=script&lang=ts"
import style0 from "./OrganisationCreated.vue?vue&type=style&index=0&id=39ac3caf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ac3caf",
  null
  
)

export default component.exports